var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-q-browser-not-supported',{attrs:{"valid-browser":_vm.isValidBrowser,"valid-platform":_vm.isValidPlatform}})}
var staticRenderFns = []

export { render, staticRenderFns }